export const globalThemeId = Symbol('globalTheme');
